import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledTitleProps } from './Subtitle.types';

export const StyledTitle = styled.h1<IStyledTitleProps>`
  display: block;
  margin: 0;
  margin-bottom: 1.25em;
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('20px')};
  font-weight: ${({ as }) => {
    if (as === 'strong') {
      return 600;
    } else {
      return 300;
    }
  }};
  line-height: 1.1;
`;
